/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { AbsorbedDoseToWaterUnit } from './AbsorbedDoseToWaterUnit';
import {
    AbsorbedDoseToWaterUnitFromJSON,
    AbsorbedDoseToWaterUnitFromJSONTyped,
    AbsorbedDoseToWaterUnitToJSON,
} from './AbsorbedDoseToWaterUnit';

/**
 * 
 * @export
 * @interface AbsorbedDoseToWater
 */
export interface AbsorbedDoseToWater {
    /**
     * 
     * @type {number}
     * @memberof AbsorbedDoseToWater
     */
    value?: number;
    /**
     * 
     * @type {AbsorbedDoseToWaterUnit}
     * @memberof AbsorbedDoseToWater
     */
    unit?: AbsorbedDoseToWaterUnit;
    /**
     * 
     * @type {string}
     * @memberof AbsorbedDoseToWater
     */
    $type?: AbsorbedDoseToWaterTypeEnum;
}


/**
 * @export
 */
export const AbsorbedDoseToWaterTypeEnum = {
    UnitsNetSerializationJsonNetUnitsNetBaseJsonConverter1ValueUnitUnitsNetIQuantityPtwUnitsNetPtwUnitsNetSerializationJsonNet: 'UnitsNet.Serialization.JsonNet.UnitsNetBaseJsonConverter`1+ValueUnit[[UnitsNet.IQuantity, Ptw.UnitsNet]], Ptw.UnitsNet.Serialization.JsonNet'
} as const;
export type AbsorbedDoseToWaterTypeEnum = typeof AbsorbedDoseToWaterTypeEnum[keyof typeof AbsorbedDoseToWaterTypeEnum];



/**
 * Check if a given object implements the AbsorbedDoseToWater interface.
 */
export function instanceOfAbsorbedDoseToWater(value?: unknown): value is AbsorbedDoseToWater {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(AbsorbedDoseToWaterTypeEnum)[0];
}

export function AbsorbedDoseToWaterFromJSON(json: any): AbsorbedDoseToWater {
    return AbsorbedDoseToWaterFromJSONTyped(json, false);
}

export function AbsorbedDoseToWaterFromJSONTyped(json: any, ignoreDiscriminator: boolean): AbsorbedDoseToWater {
    if (json == null) {
        return json;
    }
    return {
        
        'value': json['value'] == null ? undefined : json['value'],
        'unit': json['unit'] == null ? undefined : AbsorbedDoseToWaterUnitFromJSON(json['unit']),
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function AbsorbedDoseToWaterToJSON(value?: AbsorbedDoseToWater | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'value': value['value'],
        'unit': AbsorbedDoseToWaterUnitToJSON(value['unit']),
        '$type': value['$type'],
    });
}

